import { Coverage } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { useMemo } from 'react';

export const NO_COVERAGE = 'no coverage';

const hasNoCoverage = (coverage: Coverage) =>
  coverage.coverageLimit?.toLowerCase() === NO_COVERAGE ||
  coverage.coveragePremium?.toLowerCase() === NO_COVERAGE;

const useSortedCoverages = (coverages: Coverage[]) =>
  useMemo(() => {
    const withLimits = coverages.filter((coverage) => !hasNoCoverage(coverage));
    const withNoCoverage = coverages.filter((coverage) =>
      hasNoCoverage(coverage)
    );

    return [...withLimits, ...withNoCoverage];
  }, [coverages]);

export default useSortedCoverages;
